export const theme = {
  primaryColor: '#64eebc',
  secondaryColor: '#FFFFFF',
  backgroundColor: '#242424',
  secondaryBackgroundColor: 'rgba(36, 36, 36, 0.5)'
}
